<template>
  <div id="spiner" v-show="isActive || isStop" class="wrap-spiner">
  </div>
</template>

<script>
  import Spinner from 'spin'
  import inView from 'in-view/dist/in-view.min'

  export default {
    name: 'app-spiner',
    data () {
      return {
        isActive: true,
        isStop: true
      }
    },
    methods: {
      insertSpiner () {
        let opts = {
          lines: 7,
          length: 20,
          width: 5,
          radius: 16,
          scale: 0.75,
          corners: 1,
          color: '#000',
          opacity: 0.25,
          rotate: 0,
          direction: 1,
          speed: 1,
          trail: 60,
          fps: 20,
          className: 'spinner',
          shadow: false,
          hwaccel: false
        }
        let target = document.getElementById('spiner')
        new Spinner(opts).spin(target)
      }
    },
    mounted () {
      this.insertSpiner()
      this.$eventHub.$on('load-start', () => {
        this.isActive = true
      })
      this.$eventHub.$on('load-end', () => {
        this.isActive = false
      })
      this.$eventHub.$on('load-stop', () => {
        this.isStop = false
      })
      document.body.addEventListener('scroll', () => {
        if (inView.is(document.getElementById('spiner'))) {
          if (this.isActive) {
            this.$eventHub.$emit('in-view')
          }
        }
      })
    }
  }
</script>
<style scoped lang='scss'>
  .wrap-spiner {
    padding: 40px 0;
  }
</style>



// WEBPACK FOOTER //
// AppSpiner.vue?0d9d2856